var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewerTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 20,
    rx: 4,
    transform: "matrix(-1 0 0 1 8 0)",
    fill: "#fcba03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewerTraining);
export default __webpack_public_path__ + "static/media/reviewer-training.cda6e70b647f51b5bd24da8fe12faab7.svg";
export { ForwardRef as ReactComponent };